export default function Switch({ value, setValue, labels }) {
  const toggle = () => {
    setValue(!value);
  };

  return (
    <div className="switch-container">
      <span className={!value ? "active" : ""}>{labels[0]}</span>
      <label className="switch">
        <input type="checkbox" checked={value} onChange={toggle} />
        <span className="slider"></span>
      </label>
      <span className={value ? "active" : ""}>{labels[1]}</span>
    </div>
  );
}
